import React, { useState } from "react";
import "./StaticPage.css";

const FAQS = [
  {
    q: "What is Pisi Lun (Hara Namak)? Is it very spicy?",
    a: "Pisi Lun means 'ground salt' in Pahadi — a traditional Uttarakhand fusion of green chillies, salt, herbs, and mountain condiments. It's the flavored salt Pahadi families have used for generations: sprinkled on cucumber, stirred into curd, shaken into lemonade, or folded into daal. It isn't overly spicy, but because every batch is natural, we recommend tasting a little first and adding it to your dish as per your own preference. No preservatives, no artificial colour.",
  },
  {
    q: "What makes Pahadi turmeric different from regular turmeric?",
    a: "Our turmeric is cultivated in the hills of Uttarakhand without chemical fertilizers or pesticides. Grown at altitude in mineral-rich mountain soil, it develops a deeper colour, stronger aroma, and higher natural potency than mass-produced commercial turmeric.",
  },
  {
    q: "Is your honey raw and unfiltered? Will it crystallize?",
    a: "Yes — our Mountain Honey is 100% raw, unfiltered, and unprocessed, exactly as it comes from the hive. Because it's natural, it may crystallize in cooler temperatures. This is a sign of purity, not spoilage — just place the jar in warm water to gently return it to liquid. Do not refrigerate honey.",
  },
  {
    q: "Are your seed salts (Hemp / Flax) suitable for daily use?",
    a: "Yes. Our Hemp Seed Salt and Flax Seed Salt are made for everyday use — a nutritious, protein-rich way to season your meals the Pahadi way.",
  },
  {
    q: "Are your products certified organic or natural?",
    a: "All PureJar products are 100% natural with no preservatives, no artificial colours, and no added flavours. We are FSSAI licensed (22624038000343). Formal organic certification is in progress — we will update customers as soon as it is complete.",
  },
  {
    q: "Where are your products sourced from?",
    a: "Directly from the hills of Uttarakhand. Our turmeric comes from high-altitude farms, our honey from wild beehives above 6,000 ft, and our salts from traditional Pahadi recipes. We work farmer-direct to support local producers and ensure authenticity.",
  },
  {
    q: "Is Pisi Lun a replacement for regular salt? How do I use it?",
    a: "No — Pisi Lun isn't a replacement for your everyday white salt. It's a flavored companion. Enjoy it sprinkled over fruits, mixed into curd, stirred into fresh lemonade, or with sliced cucumber. It's meant to wake up flavour, not replace your table salt.",
  },
  {
    q: "What is the shelf life of your products?",
    a: "Hara Namak and Seed Salts: 12 months from manufacturing date. Turmeric Powder: 18 months. Mountain Honey: 24 months (natural honey does not expire if stored correctly). Always check the best-before date printed on the jar.",
  },
  {
    q: "How should I store the products?",
    a: "Store all products in a cool, dry place away from direct sunlight. Keep lids tightly closed after each use. Do not refrigerate honey — it can crystallise at low temperatures (crystallised honey is still safe; warm the jar gently to re-liquify). Avoid moisture contact with salts and spices.",
  },
  {
    q: "What payment methods do you accept?",
    a: "We accept all major payment modes — UPI, credit and debit cards, net banking, and popular wallets — through our secure Razorpay gateway.",
  },
  {
    q: "Do you offer Cash on Delivery (COD)?",
    a: "Yes, COD is available. A nominal COD handling fee of ₹49 applies to cover courier charges. You can also pay online to skip this fee.",
  },
  {
    q: "Can I modify or cancel my order after placing it?",
    a: "Yes — you can modify or cancel your order before it is dispatched. Just write to us quickly at orders@purejar.in with your Order ID and we'll help. Once an order is shipped, it can no longer be changed.",
  },
  {
  },
  {
    q: "How long does delivery take, and do you ship across India?",
    a: "Yes — we ship pan-India through Shiprocket courier partners like Delhivery. Delivery typically takes 4–7 business days depending on your location. Remote pincodes and certain North-East locations may take an additional 2–3 days. An estimated delivery date is shown at checkout after you enter your pincode, and you'll receive a tracking link by email once your order is dispatched.",
  },
  {
    q: "Can I return or exchange a product?",
    a: "Yes. You may raise a return request within 2 days of delivery for unopened products or products damaged in transit. Photos of the product and packaging are required. PureJar bears the return shipping cost. Refunds are processed within 5–7 business days after inspection. See our full Return & Refund Policy for details.",
  },
  {
    q: "How do I track my order?",
    a: "Once your order is shipped, you will receive an email with your AWB (tracking number) and a direct tracking link. You can also visit My Orders in your account to see the current status. For any shipping queries, write to wecare@purejar.in with your Order ID.",
  },
  {
    q: "Are you a registered company, and do you offer bulk orders?",
    a: "Yes — PureJar is a venture of Neoteric Roots Private Limited, a registered company based in Haldwani, Uttarakhand (CIN: U82990UT2023PTC016158). We are FSSAI licensed and GST registered. At the moment we do not offer bulk or wholesale orders — every jar is small-batch and made in limited quantities to preserve quality and freshness.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(null);
  return (
    <div className="static-page">
      <div className="static-container">
        <span className="section-label">Help</span>
        <h1>Frequently Asked Questions</h1>
        <p className="static-intro">
          Everything you need to know about PureJar products, orders, and delivery.
          Can't find your answer?{" "}
          <a href="mailto:wecare@purejar.in">Write to us</a>.
        </p>

        <div className="faq-watermark">FAQ</div>
        <div className="faq-list">
          {FAQS.map((item, i) => (
            <div key={i} className={`faq-item ${open === i ? "open" : ""}`}>
              <button className="faq-question" onClick={() => setOpen(open === i ? null : i)}>
                <span>{item.q}</span>
                <span className="faq-icon">{open === i ? "−" : "+"}</span>
              </button>
              {open === i && <div className="faq-answer"><p>{item.a}</p></div>}
            </div>
          ))}
        </div>

        <div className="faq-contact">
          <h3>Still have questions?</h3>
          <p>
            Write to <a href="mailto:wecare@purejar.in">wecare@purejar.in</a> and we'll
            get back to you within 24 hours.
          </p>
        </div>
      </div>
    </div>
  );
}
